<template>
  <div class="container">
    <img class="bg" :src="$getImgUrl(`/site-images/activity/ams2021/booth-share-bg.png`)">
    <div class="info" v-if="showResult">
        <div class="normal">
          <p><b>我已经在易加网获得了</b></p>
          <p><b>{{productName}}</b></p>
        </div>
        <div class="code" v-if="shareCode&&shareCode!==''">
          兑换编号:{{shareCode}}
        </div>
    </div>

  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { sessionStorageUtils } from '@/utils/sessionstorage'
export default {
  created () {
    this.init()
  },
  data () {
    return {
      shareCode: '',
      productName: '',
      showResult: false
    }
  },
  methods: {
    init () {
      let wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
      if (this.$route.query.openId && wxUserInfo) {
        let params = {
          openId: wxUserInfo.openId,
          shareOpenId: this.$route.query.openId
        }
        activityApi.boothShare(params).then(res => {
          if (res.data.resultCode === '0') {
            this.productName = res.data.resultData.productName
            if (res.data.resultData.shareCode) {
              this.shareCode = res.data.resultData.shareCode
            }
            this.showResult = true
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.container{
  width: 100%;
  height: 100%;
}
.bg{
  width: 100vw;
}
.info{
  font-size: 18px;
  position: absolute;
  top: 55px;
  width: 100%;
  text-align: center;
  color: white;
  line-height: 40px;
}
.code{
  font-size: 16px;
}
</style>
